import React from 'react'

import StartFooterCTA from './StartFooterCTA.js';


export default class extends React.Component {

  constructor(props) {
    super(props);
    this.state = {plan_active:"2"};

    this.highlightNew = this.highlightNew.bind(this);
  }

  componentDidMount() {
    var elements = document.getElementsByClassName("plan");
    for(var i = 0; i < elements.length; i++) {
      elements[i].addEventListener('mouseenter', this.highlightNew);
    }
  }

  highlightNew(e) {
    this.setState({plan_active:e.target.getAttribute("data-id")});
  }


  render() {
    document.title = this.props.i18n_texts["pricing_title"][this.props.app_language]+" · Citrus by Polymedia";
    let alt_nl = document.createElement('link');alt_nl.rel = 'alternate';alt_nl.hreflang = 'x-default';alt_nl.href = 'https://citrus.polymedia.nl/prijzen';
    document.getElementsByTagName('title')[0].after(alt_nl);
    let alt_en = document.createElement('link');alt_en.rel = 'alternate';alt_en.hreflang = 'en';alt_en.href = 'https://citrus.polymedia.nl/en/pricing';
    document.getElementsByTagName('title')[0].after(alt_en);
    //let per1 = 70.99, per6 = 304.99, per12 = 394.99; original
    let per1 = 31.00, per6 = 132.00, per12 = 180.00;
    return (
      <div>

        <div className="full greyish">
          <div className="wrap wrap-thin">
            <br/>
            {/*<h1 style={{marginBottom:".3em", fontWeight:"400", fontSize:"2.6em", textAlign:"center"}}>Sign up now, decide later</h1>*/}
            <h1 style={{marginBottom:".3em", fontWeight:"400", fontSize:"2.6em", textAlign:"center"}}>{this.props.i18n_texts["pricing_cta_title"][this.props.app_language]}</h1>
            <h2 style={{marginBottom:"5em", fontWeight:"400", fontSize:"1em", textAlign:"center"}}>{this.props.i18n_texts["pricing_cta_subtitle"][this.props.app_language]}</h2>
            <div className="card" style={{paddingTop:"3em", marginBottom:"3em"}}>
              <div>
                  <div className="col-2" style={{textAlign:"center"}}>
                    <p style={{margin:"0", fontWeight:"400", fontSize:"2em", lineHeight:"1em", textAlign:"center"}}>Pro</p>
                    <p style={{fontSize:"90%", textAlign:"center"}}>{this.props.i18n_texts["pricing_card_subtitle"][this.props.app_language]}</p>
                  </div>
                  <div className="col-2" style={{marginBottom:"2em"}}>
                    <ul style={{listStyleType:"square", paddingLeft:"1.1em"}}>
                      <li dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_card_usp1"][this.props.app_language]}}></li>
                      <li dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_card_usp2"][this.props.app_language]}}></li>
                      <li dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_card_usp3"][this.props.app_language]}}></li>
                      <li dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_card_usp4"][this.props.app_language]}}></li>
                      <li>{this.props.i18n_texts["gen_andmore"][this.props.app_language]}</li>
                    </ul>
                    <small style={{marginBottom:".3em", marginTop:"1em", opacity:".5", display:"block", fontSize:"75%", textAlign:"right"}}>{this.props.i18n_texts["pricing_card_fairuse"][this.props.app_language]}</small>
                    {/* https://www.e-conomic.com/developer/fair-use-policy In order to maintain optimal performance of our API and ensure that all partners and customers have a good experience we urge all developers to consider and optimize their calls and flows. Fair use is defined as 50.000 API calls per 24 hour period per agreement.<br><br>If an App creates an excessive load on the API, e-conomic is at liberty, without warning, to restrict the integration's access to our APIs, or the affected agreements access to the APIs. e-conomic will offer help and guide on how to optimise the technical implementation.*/}
                  </div>
              </div>
              <p style={{margin:"1.8em 0 5em", opacity:".7", fontSize:"90%", borderLeft:"2px solid #1cb0f9", paddingLeft:"1em"}}>{this.props.i18n_texts["pricing_card_introduction"][this.props.app_language]}</p>
              <div>
                <div id="plans">
                  <div className="plan-container">
                    <div className={(this.state.plan_active === "3") ? "plan active" : "plan"} data-id="3">
                      <h1>1</h1>
                      <p className="months">{this.props.i18n_texts["gen_month"][this.props.app_language]}</p>
                      <h4>€ {per1.toString().replace(".00", "")}/{this.props.i18n_texts["gen_mo"][this.props.app_language]}</h4>
                      <p className="savings">&nbsp;</p>
                      <p className="total">€ {(per1 / 30).toFixed(2).toString().replace(".", ",")}/{this.props.i18n_texts["gen_day"][this.props.app_language]}</p>
                    </div>
                  </div>
                  <div className="plan-container">
                    <div className={(this.state.plan_active === "2") ? "plan active" : "plan"} data-id="2">
                      <span className="value-label favorite">{this.props.i18n_texts["gen_recommended"][this.props.app_language]}</span>
                      <h1>6</h1>
                      <p className="months">{this.props.i18n_texts["gen_months"][this.props.app_language]}</p>
                      <h4>€ {(per6 / 6).toFixed(2).toString().replace(".00", "")}/{this.props.i18n_texts["gen_mo"][this.props.app_language]}</h4>
                      <p className="savings">{this.props.i18n_texts["gen_save"][this.props.app_language]} {(100 - (per6 / 6 / per1 * 100)).toFixed(0).toString().replace(".", ",")}%</p>
                      <p className="total">€ {(per6 / 182).toFixed(2).toString().replace(".", ",")}/{this.props.i18n_texts["gen_day"][this.props.app_language]}</p>
                    </div>
                  </div>
                  <div className="plan-container">
                    <div className={(this.state.plan_active === "1") ? "plan active" : "plan"} data-id="1">
                      <span className="value-label">BEST VALUE</span>
                      <h1>12</h1>
                      <p className="months">{this.props.i18n_texts["gen_months"][this.props.app_language]}</p>
                      <h4>€ {(per12 / 12).toFixed(2).toString().replace(".00", "")}/{this.props.i18n_texts["gen_mo"][this.props.app_language]}</h4>
                      <p className="savings">{this.props.i18n_texts["gen_save"][this.props.app_language]} {(100 - (per12 / 12 / per1 * 100)).toFixed(0).toString().replace(".", ",")}%</p>
                      <p className="total">€ {(per12 / 365).toFixed(2).toString().replace(".", ",")}/{this.props.i18n_texts["gen_day"][this.props.app_language]}</p>
                    </div>
                  </div>
                </div>
              </div>
              <small style={{marginBottom:".3em", marginTop:"1em", opacity:".5", display:"block", fontSize:"75%", textAlign:"right"}}>{this.props.i18n_texts["pricing_card_vat"][this.props.app_language]}</small>
              <div style={{textAlign:"center"}}><button onClick={() => this.props.openModal("register")} className="btn btn-b btn-fat" style={{margin:"2em 0"}}>{this.props.i18n_texts["cta_title"][this.props.app_language]}</button></div>
            </div>
            <p style={{margin:"1.8em 0 5em", opacity:".7", fontSize:"90%", borderLeft:"2px solid #1cb0f9", paddingLeft:"1em"}}>{this.props.i18n_texts["pricing_card_explained"][this.props.app_language]}</p>

            <h2 dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_faq_title"][this.props.app_language]}}></h2>
            <h3 dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_faq1_title"][this.props.app_language]}}></h3>
            <p dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_faq1_text"][this.props.app_language]}}></p>
            <h3 dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_faq2_title"][this.props.app_language]}}></h3>
            <p dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_faq2_text"][this.props.app_language]}}></p>
            <h3 dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_faq3_title"][this.props.app_language]}}></h3>
            <p dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_faq3_text"][this.props.app_language]}}></p>
            <h3 dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_faq4_title"][this.props.app_language]}}></h3>
            <p dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_faq4_text"][this.props.app_language]}}></p>
            
            <br/><br/><br/>
            
            <p dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_contact"][this.props.app_language]}}></p>

          </div>
        </div>

        <StartFooterCTA lang={this.props.app_language} openModal={this.props.openModal} />

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/StartPages/Pricing.js